export default __webpack_public_path__ + "static/media/Curious_Minds_LE.17f0ff42.jpg";